import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ModulesComponent} from './modules/modules.component';
import {OutwardChecksComponent} from './outward-checks/outward-checks.component';
import {FlipModule} from 'ngx-flip';
import {AppRoutingModule} from '../app-routing.module';

@NgModule({
    declarations: [
        ModulesComponent,
        OutwardChecksComponent,
    ],
    imports: [
        CommonModule,
        FlipModule,
        AppRoutingModule,

    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AllModuleModule {
}
